import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const yearArr = (() => {
  const result = []
  let year = new Date().getFullYear()
  const baseYear = year - 5

  do {
    result.push(year)
    year--
  } while (baseYear <= year)

  return result
})()

const defaultState = {
  isOpenRadio: false,
  isOpenSelect: false,
  startDate: '',
  endDate: '',
  month: 1,
  selectedMonth: 0,
  selectedYear: yearArr[0],
  yearArr: yearArr,
  monthArr: []
}

export default {
  namespaced: true,
  state: defaultState,
  actions,
  getters,
  mutations
}
